import { MenuConfigurationKey } from "@scenes/pdp/types";
import useGetProfileSettings from "./useGetProfileSettings";
import { ScreenName } from "@utils/constants";
import useTabsData from "@navigations/utils/useSortedSections";

const hooks = {
  profile: () => useGetProfileSettings(MenuConfigurationKey.MORE_SETTINGS),
  tabs: () => useTabsData(),
  // EXPLORE: useGetExploreSection,
  // FAVORITES: useGetFavoritesSection,
};

export const useGetScreenData = (screenName: ScreenName) => {
  const selectedHook = hooks[screenName];

  if (selectedHook) {
    return selectedHook();
  }

  console.warn(`No Data`);
  return null;
};
